import React from "react";

const items = [
  "Americano",
  "Live scoring",
  "0-15-30-40",
  "Golden Point",
  "Podium",
  "Rankings",
  "Community",
  "Iso · Android",
];

export default function Ticker() {
  return (
    <div
      data-testid="ticker-strip"
      className="border-y border-neutral-900 bg-black overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-ticker py-4">
        {[...items, ...items, ...items].map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-6 font-display text-2xl uppercase tracking-tight"
          >
            <span className={i % 3 === 0 ? "text-[#D4F34A]" : "text-white"}>
              {t}
            </span>
            <span className="text-neutral-700">✕</span>
          </div>
        ))}
      </div>
    </div>
  );
}
